/**
 * Generates a color based on usage percentage:
 * - Less than 0%: Blue (#22a2ca)
 * - Between 0% and 33%: Green (#34c38f)
 * - Between 33% and 66%: Yellow (#ffd992)
 * - Between 66% and 100%: Orange (#e3a63d)
 * - Greater than 100%: Red (#f46a6a)
 */
export const generateUsageColor = (usage: number) => {
	if (usage < 0) return '#22a2ca'; // Blue
	if (usage >= 0 && usage < 33) return '#34c38f'; // Green
	if (usage >= 33 && usage < 66) return '#ffd992'; // Yellow
	if (usage >= 66 && usage <= 100) return '#e3a63d'; // Orange
	return '#f46a6a'; // Red
};